var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-close-button text-xs-right",class:{absolute: _vm.absolute}},[_c('VIcon',{style:({color: _vm.color}),on:{"click":_vm.closeAction}},[_vm._v("mdi-close")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }